/** A throw inside a screen renders here, still inside the shell — nav and context are kept. */

import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

import { ErrorState } from '@/shared/ui/states';

export function ShellErrorBoundary() {
  const error = useRouteError();
  const navigate = useNavigate();

  const notFound = isRouteErrorResponse(error) && error.status === 404;

  return (
    <Stack spacing={2} sx={{ maxWidth: 640 }}>
      <ErrorState
        title={notFound ? 'That screen does not exist' : 'This screen could not be shown'}
        body={
          notFound
            ? 'The link may be out of date, or the screen may land in a later phase.'
            : 'Nothing was changed. Go back and try again — if it keeps happening, note what you were doing and tell the owner.'
        }
      />
      <Button variant="outlined" sx={{ alignSelf: 'flex-start' }} onClick={() => void navigate('/')}>
        Back to the dashboard
      </Button>
    </Stack>
  );
}
